import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'
import useBrowserTabTitle from '../../hooks/useBrowserTabTitle'

const ReportTypes = () => {
    useBrowserTabTitle('Report Types')

    const table = useRef(null)
    const urlGetData = '/v0/report_types'
    const localStorageOrderKey = 'tblReportTypesOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'name' }
    ]

    const tableHead = (
        <tr>
            <th>Name</th>
        </tr>
    )

    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/report_types/${row.id}`),
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Report Types</h2>

                            <div className="pre-table-buttons">
                                <Link to="/cadm/report_types/new" className="btn btn-mr btn-primary" type="button">New Report Type</Link>
                                <Link to="/cadm/report_schemes">Report Schemes</Link>
                            </div>
                            
                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ReportTypes
